import { isObject } from 'lodash';
import SocketWorker from './SocketWorker';

export function socketConnection(params) {
  let userId = '';
  let companyId = '';

  if (isObject(params) && params.user) {
    companyId = params.user.companyId;
    userId = params.user.id;
  }

  if (!companyId || !userId) {
    console.error('socketConnection: companyId ou userId inválidos', {
      companyId,
      userId,
    });
    return null;
  }

  return SocketWorker(companyId, userId);
}
